// import { useState } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import PropTypes from 'prop-types';
// // hooks
// import useAuth from '../hooks/useAuth';
// // pages
// import Login from '../pages/authentication/Login';

// // ----------------------------------------------------------------------

// AuthGuard.propTypes = {
//   children: PropTypes.node
// };

// export default function AuthGuard({ children }) {
//   const { isAuthenticated } = useAuth();
//   console.log('isAuthenticated', isAuthenticated)
//   const { pathname } = useLocation();
//   const [requestedLocation, setRequestedLocation] = useState(null);

//   if (!isAuthenticated) {
//     if (pathname !== requestedLocation) {
//       setRequestedLocation(pathname);
//     }
//     return <Login />;
//   }

//   if (requestedLocation && pathname !== requestedLocation) {
//     setRequestedLocation(null);
//     return <Navigate to={requestedLocation} />;
//   }

//   return <>{children}</>;
// }
import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import LoadingScreen from '../components/LoadingScreen';

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  useEffect(() => {
    if (!requestedLocation && !isAuthenticated) {
      setRequestedLocation(pathname);
    }
  }, [pathname, isAuthenticated, requestedLocation]);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    const redirectPath = requestedLocation;
    setRequestedLocation(null);
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}
